// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetLatest (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostOrdersHistory (params?: {}): Promise<Dict>;
    privatePostMyCoinDeposit (params?: {}): Promise<Dict>;
    privatePostMyCoinSend (params?: {}): Promise<Dict>;
    privatePostQuoteBuy (params?: {}): Promise<Dict>;
    privatePostQuoteSell (params?: {}): Promise<Dict>;
    privatePostMyBalances (params?: {}): Promise<Dict>;
    privatePostMyOrders (params?: {}): Promise<Dict>;
    privatePostMyBuy (params?: {}): Promise<Dict>;
    privatePostMySell (params?: {}): Promise<Dict>;
    privatePostMyBuyCancel (params?: {}): Promise<Dict>;
    privatePostMySellCancel (params?: {}): Promise<Dict>;
    privatePostRoMyBalances (params?: {}): Promise<Dict>;
    privatePostRoMyBalancesCointype (params?: {}): Promise<Dict>;
    privatePostRoMyDeposits (params?: {}): Promise<Dict>;
    privatePostRoMyWithdrawals (params?: {}): Promise<Dict>;
    privatePostRoMyTransactions (params?: {}): Promise<Dict>;
    privatePostRoMyTransactionsCointype (params?: {}): Promise<Dict>;
    privatePostRoMyTransactionsOpen (params?: {}): Promise<Dict>;
    privatePostRoMyTransactionsCointypeOpen (params?: {}): Promise<Dict>;
    privatePostRoMySendreceive (params?: {}): Promise<Dict>;
    privatePostRoMyAffiliatepayments (params?: {}): Promise<Dict>;
    privatePostRoMyReferralpayments (params?: {}): Promise<Dict>;
    v2PublicGetLatest (params?: {}): Promise<Dict>;
    v2PublicGetLatestCointype (params?: {}): Promise<Dict>;
    v2PublicGetLatestCointypeMarkettype (params?: {}): Promise<Dict>;
    v2PublicGetBuypriceCointype (params?: {}): Promise<Dict>;
    v2PublicGetBuypriceCointypeMarkettype (params?: {}): Promise<Dict>;
    v2PublicGetSellpriceCointype (params?: {}): Promise<Dict>;
    v2PublicGetSellpriceCointypeMarkettype (params?: {}): Promise<Dict>;
    v2PublicGetOrdersOpenCointype (params?: {}): Promise<Dict>;
    v2PublicGetOrdersOpenCointypeMarkettype (params?: {}): Promise<Dict>;
    v2PublicGetOrdersCompletedCointype (params?: {}): Promise<Dict>;
    v2PublicGetOrdersCompletedCointypeMarkettype (params?: {}): Promise<Dict>;
    v2PublicGetOrdersSummaryCompletedCointype (params?: {}): Promise<Dict>;
    v2PublicGetOrdersSummaryCompletedCointypeMarkettype (params?: {}): Promise<Dict>;
    v2PrivatePostStatus (params?: {}): Promise<Dict>;
    v2PrivatePostMyCoinDeposit (params?: {}): Promise<Dict>;
    v2PrivatePostQuoteBuyNow (params?: {}): Promise<Dict>;
    v2PrivatePostQuoteSellNow (params?: {}): Promise<Dict>;
    v2PrivatePostQuoteSwapNow (params?: {}): Promise<Dict>;
    v2PrivatePostMyBuy (params?: {}): Promise<Dict>;
    v2PrivatePostMyBuyEdit (params?: {}): Promise<Dict>;
    v2PrivatePostMySell (params?: {}): Promise<Dict>;
    v2PrivatePostMySellEdit (params?: {}): Promise<Dict>;
    v2PrivatePostMyBuyNow (params?: {}): Promise<Dict>;
    v2PrivatePostMyBuyNowCoinlist (params?: {}): Promise<Dict>;
    v2PrivatePostMySellNow (params?: {}): Promise<Dict>;
    v2PrivatePostMySellNowCoinlist (params?: {}): Promise<Dict>;
    v2PrivatePostMySwapNow (params?: {}): Promise<Dict>;
    v2PrivatePostMyBuyCancel (params?: {}): Promise<Dict>;
    v2PrivatePostMyBuyCancelAll (params?: {}): Promise<Dict>;
    v2PrivatePostMySellCancel (params?: {}): Promise<Dict>;
    v2PrivatePostMySellCancelAll (params?: {}): Promise<Dict>;
    v2PrivatePostMyCoinWithdrawSenddetails (params?: {}): Promise<Dict>;
    v2PrivatePostMyCoinWithdrawSend (params?: {}): Promise<Dict>;
    v2PrivatePostMyCoinWithdrawSendAsync (params?: {}): Promise<Dict>;
    v2PrivatePostMyCoinWithdrawSendStatus (params?: {}): Promise<Dict>;
    v2PrivatePostRoStatus (params?: {}): Promise<Dict>;
    v2PrivatePostRoOrdersMarketOpen (params?: {}): Promise<Dict>;
    v2PrivatePostRoOrdersMarketCompleted (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyBalances (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyBalanceCointype (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyOrdersMarketOpen (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyOrdersLimitOpen (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyOrdersCompleted (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyOrdersMarketCompleted (params?: {}): Promise<Dict>;
    v2PrivatePostRoMySendreceive (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyDeposits (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyWithdrawals (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyAffiliatepayments (params?: {}): Promise<Dict>;
    v2PrivatePostRoMyReferralpayments (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
